<template>
  <div>
    <el-card>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-date-picker
            v-model="dateValue"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="发送开始日期"
            end-placeholder="发送结束日期"
            value-format="timestamp"
            @change="timeChange"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-col>
      </el-row>
    </el-card>
    <div class="chart-container">
      <div ref="dailyChart" style="width: 100%; height: 500px;"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'MultiLineDailyChartWithSummary',
  data () {
    return {
      chartInstance: null,
      mockData: [],
      param: {
        start_time: 0,
        end_time: 0
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      dateValue: ''
    }
  },
  mounted () {
    this.defaultTime()
    this.getList()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    if (this.chartInstance) {
      this.chartInstance.dispose()
    }
  },
  methods: {
    async getList () {
      const res = await this.$http.get('/admin/gh_sub_log/overview', this.param)
      if (res.code === 0) {
        this.mockData = res.data
        this.initChart()
      } else {
        this.$message.error(res.msg)
      }
    },
    defaultTime () {
      const now = new Date()
      now.setHours(0, 0, 0, 0)
      this.param.start_time = now.getTime() / 1000 - 7 * 86400
      this.param.end_time = now.getTime() / 1000 + 86399
      this.dateValue = [this.param.start_time * 1000, this.param.end_time * 1000]
    },
    timeChange () {
      if (this.dateValue !== null) {
        this.param.start_time = this.dateValue[0] / 1000
        this.param.end_time = this.dateValue[1] / 1000 + 86399
      } else {
        this.param.start_time = 0
        this.param.end_time = 0
      }
      this.getList()
    },
    initChart () {
      this.chartInstance = echarts.init(this.$refs.dailyChart)

      const dates = this.mockData.map(item => item.date)

      // 1. 计算各状态的总和
      const totalSuccess = this.mockData.reduce((sum, item) => sum + item.success, 0)
      const totalFailed = this.mockData.reduce((sum, item) => sum + item.failed, 0)
      const totalIsRead = this.mockData.reduce((sum, item) => sum + item.is_read, 0)
      const grandTotal = totalSuccess + totalFailed

      // 2. 计算占比（保留一位小数）
      const formatPercent = (val) => grandTotal > 0 ? ((val / grandTotal) * 100).toFixed(2) : '0.00'

      // 3. 配置 ECharts 选项
      const option = {
        title: {
          text: '每日发送数据统计',
          left: 'center',
          top: 10
        },
        // 核心：使用 graphic 组件在标题下方绘制文本
        graphic: [
          {
            type: 'text',
            left: 'center',
            top: 45, // 位于标题正下方
            style: {
              text: `总计: ${grandTotal}  |  成功: ${totalSuccess} (${formatPercent(totalSuccess)}%)  |  失败: ${totalFailed} (${formatPercent(totalFailed)}%)  |  已读: ${totalIsRead} (${formatPercent(totalIsRead)}%)`,
              fontSize: 14,
              fill: '#666',
              fontWeight: 'bold'
            }
          }
        ],
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' }
        },
        legend: {
          bottom: 0,
          data: ['成功', '失败', '已读']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          top: 80, // ⚠️ 注意：必须调大 top 值，防止折线被顶部的汇总文字遮挡
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dates
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '成功',
            type: 'line',
            smooth: true,
            data: this.mockData.map(item => item.success),
            itemStyle: { color: '#E6A23C' }
          },
          {
            name: '失败',
            type: 'line',
            smooth: true,
            data: this.mockData.map(item => item.failed),
            itemStyle: { color: '#F56C6C' }
          },
          {
            name: '已读',
            type: 'line',
            smooth: true,
            data: this.mockData.map(item => item.is_read),
            itemStyle: { color: '#67C23A' }
          }
        ]
      }

      this.chartInstance.setOption(option)
    },
    handleResize () {
      if (this.chartInstance) {
        this.chartInstance.resize()
      }
    }
  }
}
</script>
<style scoped>
.chart-container {
  width: 100%;
  padding: 20px;
  margin-top: 10px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>
